import { BaseRouteService } from 'core/services';

class HistoryLogRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'history-logs/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed,source,itemId}', id, options);
	}

	create() {
		return super.create(this.base);
	}

	update(resource) {
		return super.update(this.base + '{id}', resource);
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default HistoryLogRouteService;
